module.exports = __webpack_public_path__ + "img/appIcon-fiscal--Status__success.2e3c290c.svg";